const toast = {
  install(vue, store) {
    let domt = document.createElement("div");
    domt.id = "toast";
    document.body.appendChild(domt);
    const t = vue.extend({
      name: "toast",
      render(h) {
        return h(
          "transition",
          {
            attrs: {
              name: "fade",
            },
          },
          [this.showToast ? h("p", { class: "toast" }, this.text) : ""]
        );
      },
      data() {
        return {
          showToast: false,
          text: "这是个toast",
        };
      },
      methods: {
        toast(text, time = 1000) {
          if (!text) {
            return;
          }
          this.text = store.state.langTexts[text] || text;
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, time);
        },
      },
    });
    const to = new t().$mount("#toast");
    vue.prototype.$toast = window.$toast = to.toast;
  },
};
export default toast;
